<template>
  <div style="position: relative">
    <!-- {{ result_value }} -->
    <div v-for="i in namelist" :key="i">
      <vs-icon
        icon="circle"
        :class="i.class"
        size="large"
        :id="i.id"
        color="rgb(0, 0, 0,0)"
      ></vs-icon>

      <b-tooltip :target="i.id" variant="light" triggers="hover">
        <div class="p-2">
          <h4 style="font-weight: 600">{{ i.text }}</h4>
        </div>
      </b-tooltip>
    </div>
    <div v-for="i in sensorlist" :key="i">
      <img
        src="@/assets/images/yamahaaqi/icon_sensor_crop.gif"
        :class="i.class"
        :id="i.id"
      />

      <b-tooltip :target="i.id" variant="warning" triggers="hover">
        <div class="p-2">
          <h4 style="font-weight: 600">{{ i.text }}</h4>
          <div class="mt-1" v-for="(b, index) in i.text2" :key="index">
            {{ b }}
            {{ result_value[i.key][i.data[index]] }}
            {{ i.unit[index] }}
          </div>
        </div>
      </b-tooltip>
    </div>
    <img
      id="myImg"
      class="imgmap"
      src="@/assets/images/yamahaaqi/map_withoutsensor.png"
    />
  </div>
</template>

<script>
export default {
  name: "App",
  props: ["result_value"],
  data() {
    return {
      sensorlist: [
        {
          id: "position-sensor-1",
          class: "icon-large-s p-ab po-s-1",
          iconcolor: "#f1f51b",
          key: "48FFFF661CAB",
          text: "TVOCs Station (BUSP)",
          text2: ["TVOC : "],
          data: ["TVOC"],
          unit: ["ppm"],
        },
        {
          id: "position-sensor-2",
          class: "icon-large-s p-ab po-s-2",
          key: "48FFFF662208",
          iconcolor: "#f1f51b",
          text: "TVOCs Station (MC)",
          // text: "TVOCs Station",
          data: ["TVOC"],
          text2: ["TVOC : "],
          unit: ["ppm"],
        },
        {
          id: "position-sensor-3",
          class: "icon-large-s p-ab po-s-3",
          key: "48FFFF661AD3",
          iconcolor: "#f1f51b",
          text: "TVOCs Station (PTPS)",
          data: ["TVOC"],
          text2: ["TVOC : "],
          unit: ["ppm"],
        },
        {
          id: "position-sensor-4",
          class: "icon-large-s p-ab po-s-4",
          key: "48FFFF661994",
          iconcolor: "#f1f51b",
          data: ["TVOC"],
          text: "TVOCs Station (UDGT)",
          text2: ["TVOC : "],
          unit: ["ppm"],
        },
        {
          id: "position-sensor-5",
          class: "icon-large-s p-ab po-s-5",
          key: "air_polution",
          iconcolor: "#1111d9",
          text: "Weather Station",
          text2: [
            "Temperature : ",
            "Relative Humidity : ",
            "PM2.5 : ",
            "PM10 : ",
          ],
          unit: ["°C", "%", "µg/m3", "µg/m3"],
          data: ["ambient_temp", "humidity", "pm25", "pm10"],
        },
        {
          id: "position-sensor-6",
          class: "icon-large-s p-ab po-s-6",
          key: "48FFFF661CD6",
          iconcolor: "#4af51b",
          text: "Wind Station",
          text2: ["Wind Speed : ", "Wind Direction : "],
          data: ["wind_speed", "wind_direction"],
          unit: ["m/s", "°"],
        },
      ],
      namelist: [
        {
          id: "position1",
          class: "icon-large p-ab po-1",
          text: "YRA",
        },
        {
          id: "position2",
          class: "icon-large p-ab po-2",
          text: "PART WAREHOUSE",
        },
        {
          id: "position3",
          class: "icon-large p-ab po-3",
          text: "PART CENTER&SERVICE",
        },
        {
          id: "position4",
          class: "icon-large p-ab po-4",
          text: "PLASTIC PAINTING",
        },
        {
          id: "position5",
          class: "icon-large p-ab po-5",
          text: "MACHINING",
        },
        {
          id: "position6",
          class: "icon-large p-ab po-6",
          text: "OFFICE",
        },
        {
          id: "position7",
          class: "icon-large p-ab po-7",
          text: "IMPORT WAREHOUSE",
        },
        {
          id: "position8",
          class: "icon-large p-ab po-8",
          text: "AL-PAINTING",
        },
        {
          id: "position9",
          class: "icon-large p-ab po-9",
          text: "OM ASSEMBLY",
        },
        {
          id: "position10",
          class: "icon-large p-ab po-10",
          text: "WELDING",
        },
        {
          id: "position11",
          class: "icon-large p-ab po-11",
          text: "ED PAINTING",
        },
        {
          id: "position12",
          class: "icon-large p-ab po-12",
          text: "YMAC",
        },
        {
          id: "position13",
          class: "icon-large p-ab po-13",
          text: "OFFICE MAINTENANCE",
        },
        {
          id: "position14",
          class: "icon-large p-ab po-14",
          text: "WAREHOUSE",
        },
        {
          id: "position15",
          class: "icon-large p-ab po-15",
          text: "WASTEWATER TRETMENT PLANT",
        },
        {
          id: "position16",
          class: "icon-large p-ab po-16",
          text: "IMPORT SHOP",
        },
        {
          id: "position17",
          class: "icon-large p-ab po-17",
          text: "E/G ASSEMBLY",
        },
        {
          id: "position18",
          class: "icon-large p-ab po-18",
          text: "B/D ASSEMBLY",
        },
        {
          id: "position19",
          class: "icon-large p-ab po-19",
          text: "CANTEEN",
        },
        {
          id: "position20",
          class: "icon-large p-ab po-20",
          text: "IMPORT-EXPORT",
        },
      ],
      // pm10value: null,
    };
  },
  methods: {},
  created() {
    // this.pm10value = (
    //   parseFloat(this.result_value.air_polution.pm10) / 1000
    // ).toFixed(2);
    // this.data = this.$session.get("data");
  },
};
</script>

<style scoped>
.tooltip-inner2 {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: pink;
  border-radius: 15px;
}
.icon-large {
  font-size: 3.125rem;
  width: 3.125rem;
  height: 3.125rem;
}
.icon-large-s {
  /* font-size: 1.5rem; */
  width: 5%;
  height: 10%;
}
.p-ab {
  position: absolute;
  cursor: pointer;
}
.imgmap {
  /* height: 17vw; */
  width: 95%;
  margin-top: 5px;
  top: 0;
  left: 0;
}
.po-s-1 {
  top: 29%;
  left: 56.5%;
}
.po-s-2 {
  top: 23%;
  left: 43%;
}
.po-s-3 {
  top: 9%;
  left: 47%;
}
.po-s-4 {
  top: 10%;
  left: 60%;
}
.po-s-5 {
  top: 30%;
  left: 59%;
}
.po-s-6 {
  top: 19%;
  left: 29%;
}
.po-1 {
  top: 29%;
  right: 11%;
}
.po-2 {
  top: 22%;
  right: 22%;
}
.po-3 {
  top: 20%;
  right: 27%;
}
.po-4 {
  top: 17%;
  right: 44%;
}
.po-5 {
  top: 13%;
  left: 38%;
}
.po-6 {
  top: 10%;
  left: 29%;
}
.po-7 {
  top: 10%;
  left: 20%;
}
.po-8 {
  top: 19%;
  left: 16.5%;
}
.po-9 {
  top: 27%;
  left: 14.5%;
}
.po-10 {
  top: 35%;
  left: 13%;
}
.po-11 {
  top: 42.5%;
  left: 11.5%;
}
.po-12 {
  top: 50%;
  left: 10%;
}
.po-13 {
  top: 64%;
  left: 3%;
}
.po-14 {
  top: 68%;
  left: 13%;
}
.po-15 {
  top: 61%;
  left: 29%;
}
.po-16 {
  top: 60%;
  left: 22%;
}
.po-17 {
  top: 45%;
  left: 23.5%;
}
.po-18 {
  top: 31%;
  left: 25%;
}
.po-19 {
  top: 21%;
  left: 27%;
}
.po-20 {
  top: 38%;
  right: 53%;
}
@media screen and (max-width: 1180px) {
  .icon-large {
    font-size: 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
  }
  .icon-large-s {
    /* font-size: 0.5rem; */
    /* width: 50%;
    height: 50%; */
  }
}
</style>